import React from "react";
import CustomAvailableItems from "../../CustomAvailableAssignedItems/CustomAvailableItems";
import { IconDocumentLinedGrid } from "../../buttons/IconButtons";
import { VIEW_TYPE } from "../../../enums/ViewType";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Generic Add tab for a shift-resource section. Left: server search of the
 * catalog; right: the locally selected items. Selection writes straight into
 * the section list (client-side). Domain-agnostic: the per-module config comes
 * from the `useAddApp` hook passed in (resolves dynamicConfig for the resource).
 *
 * @param {Object} props
 * @param {Function} props.useAddApp - Domain hook: ({resource, id}) => ({ dynamicConfig }).
 * @param {string} props.resource - Resource type handled by this section.
 * @param {number|string|null|undefined} props.id - Shift id; absent in create.
 * @param {Array<Object>} props.selected - Section selection list.
 * @param {Function} props.setSelected - Section selection setter.
 */
const AddTabResource = (props) => {
    const {
        useAddApp,
        setBodyForExport,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        modified,
        setModified,
        selected,
        setSelected,
        resource,
        id,
        emptyFields,
    } = props;

    const { dynamicConfig } = useAddApp({ resource, id });

    return (
        <CustomAvailableItems
            id={id}
            setBodyForExport={setBodyForExport}
            results={results}
            setResults={setResults}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            selected={selected}
            setSelected={setSelected}
            tableIconTitle={<IconDocumentLinedGrid height={16} width={16} className={"mr-8px mb-1 icon-color-general-950"} />}
            labelRowsPerPage={dynamicConfig.labelRowsPerPage}
            tableNotInformationLegend={dynamicConfig.tableNotInformationLegend}
            selectedSectionNotInformationLegend={'no_items_added_yet'}
            tableBuildBody={({ page, rowsPerPage, searchElement }) =>
                dynamicConfig.buildBody({ page, rowsPerPage, searchElement })
            }
            tableEndPoint={dynamicConfig.api}
            keyId={dynamicConfig.keyId}
            viewTypeName={VIEW_TYPE.GRID.name}
            titleContainer={dynamicConfig.titleContainer}
            selectedSectionTitle={dynamicConfig.selectTitleContainer}
            searchTitle={dynamicConfig.searchLabel}
            selectedSectionIconTitle={dynamicConfig.selectedSectionIconTitle}
            tableTitle={true}
            renderAvailableItem={dynamicConfig.renderAvailableItem}
            renderSelectedItems={dynamicConfig.renderSelectedItems}
            emptyFields={emptyFields}
        />
    );
}

export default AddTabResource
